import { Component, Story, Knobs } from './DocTypes';

const FourLevelKnobs: Knobs = {
  collapsed: { default: false, editor: 'checkbox' },
  hideTextOnCollapsed: { default: false, editor: 'checkbox' },
  selectedMenuItemId: { default: 'e0e56515-8b91-475e-b020-bc0fcdcf1190', editor: 'textbox' },
  width: {
    default: '',
    editor: 'textbox',
  },
};
const FourLevelItemsArray = `[
  { id: '185a5619-a0c1-4fce-bf93-2d6f37ec205b', text: 'Customers', icon: 'Users',listItemSelectedStyle: '{"background-color": "#E0E3E7"}'},
  {
    id: '46c0e912-84a9-4b25-8526-41b117899175',
    text: 'Cases',
    icon: 'Ticket',
    badgeText: '5',
    badgeAccent: 'sunflower',
    listItemSelectedStyle: '{"background-color": "#E0E3E7"}',
    children: [
      {
        id: '112ddc09-f2e5-46d2-8170-2f6ca36367b0',
        text: 'Open',
        icon: 'FolderOpen',
        badgeText: '5',   
        listItemSelectedStyle: '{"background-color": "#E0E3E7"}',     
        children: [
          {
            id: '4c15fdc9-f120-43a4-85b3-2bec0ba128db',
            text: 'Urgent',
            badgeText: '1',
            badgeAccent: 'access',
            listItemSelectedStyle: '{"background-color": "#E0E3E7"}',
            children: [
              { id:'d4237152-791f-4037-8790-48e3eaaf7dc8', text: 'Go to', listItemSelectedStyle: '{"background-color": "#E0E3E7"}', badgeText: '1', badgeAccent: "access" },
              { id: 'c2dbaa07-28f5-403c-8d42-2fdaa94d24ac', text: 'Escalate', listItemSelectedStyle: '{"background-color": "#E0E3E7"}'}
            ]
          },
          {
            id: 'a4b40200-66ad-4cf8-8420-68cbae946a62',
            text: 'Normal',
            listItemSelectedStyle: '{"background-color": "#E0E3E7"}',
            children: [
              { id: '19266f05-c86b-469a-a033-7125063e0a4f', text: 'Go to', listItemSelectedStyle: '{"background-color": "#E0E3E7"}'},
              { id: '2eb8a9f0-3e4f-43c7-83b8-c71f236899fb', text: 'Escalate',	listItemSelectedStyle: '{"background-color": "#E0E3E7"}' }
            ]
          },
          {
            id: 'bfbb35ef-2d15-4c1a-a867-b786a7166dd5',
            text: 'Low',
            badgeText: '2',
            listItemSelectedStyle: '{"background-color": "#E0E3E7"}',
          }
        ]
      },
      {
        id: '112ddc09-f2e5-46d2-8170-2f6ca36367b1',
        text: 'Close',
        icon: 'Folder',
        badgeText: '5',   
        badgeAccent: 'access',
        listItemSelectedStyle: '{"background-color": "#E0E3E7"}',    
      }
    ]
  },
  { id: 'e0e56515-8b91-475e-b020-bc0fcdcf1190', text: 'Reports', icon: 'ReportTable', listItemSelectedStyle: '{"background-color": "#E0E3E7"}', badgeText: '9+', badgeAccent: 'coral' }
]`;
const FourLevelStory: Story = {
  title: 'Four level',
  description: 'Four level left hand navigation bar with badges',
  coreComponent: {
    html: `<tag-nav {{...knobs}}>
</tag-nav>`,
    knobs: FourLevelKnobs,
    js: `var nav = document.querySelector('tag-nav');
var items = ${FourLevelItemsArray}

nav.componentOnReady().then(function() {
  nav.setData(items);
})`,
  },
  reactWrapper: {
    jsx: `<TagNav {{...knobs}}
  items={${FourLevelItemsArray}}
/>`,
    knobs: FourLevelKnobs,
  },
};

const customStylesArray = `[
  {
    text: 'Reporting',
    icon: 'LineChartArrow',
    listItemLinkTextStyle: '{"font-weight": "400"}',
    listItemSelectedLinkTextStyle: '{"font-weight": "700"}',
  },
  {
    text: 'Billing',
    icon: 'Pound',
    listItemStyle: '{"background-Color": "#b2cfbb"}',
    listItemLinkTextStyle: '{"font-weight": "400"}',
    listItemSelectedLinkTextStyle: '{"font-weight": "700"}'
  },
  {
    text: 'Configuration',
    icon: 'Settings',
    containerStyle: '{"background-Color": "#fff"}',
    listItemOpenMenuLinkStyle: '{"background-color": "#712e58"}',
    children: [
      {
        text: 'Customer',
        icon: 'User',
        listItemLinkTextStyle: '{"font-weight": "400"}',
        listItemSelectedLinkTextStyle: '{"font-weight": "700"}'
      },
      {
        text: 'Brands',
        icon: 'Building',
        listItemLinkTextStyle: '{"font-weight": "400"}',
        listItemSelectedLinkTextStyle: '{"font-weight": "700"}'
      },
      {
        text: 'Document Types',
        icon: 'Doc',
        listItemLinkTextStyle: '{"font-weight": "400"}',
        listItemSelectedLinkTextStyle: '{"font-weight": "700"}'
      },
      {
        text: 'Document Library',
        icon: 'Folder2',
        listItemLinkTextStyle: '{"font-weight": "400"}',
        listItemSelectedLinkTextStyle: '{"font-weight": "700"}'
      },
      {
        text: 'E-Signature',
        icon: 'Edit',
        containerStyle: '{"background-Color": "#fff"}',
        listItemOpenMenuLinkTextStyle: '{"color": "#712e58", "font-weight": "700"}',
        children: [
          {
            text: 'Documents',
            listItemLinkTextStyle: '{"font-weight": "400"}',
            listItemSelectedLinkTextStyle: '{"font-weight": "700"}'
          },
          {
            text: 'Digital Form Templates',
            listItemLinkTextStyle: '{"font-weight": "400"}',
            listItemSelectedLinkTextStyle: '{"font-weight": "700"}'
          }
        ]
      },
      {
        text: 'Users & Permissions',
        icon: 'Users',
        listItemLinkTextStyle: '{"font-weight": "400"}',
        listItemSelectedLinkTextStyle: '{"font-weight": "700"}'
      }
    ]
  },
  {
    text: 'Management',
    icon: 'Clipboard',
    listItemLinkTextStyle: '{"font-weight": "400"}',
    listItemSelectedLinkTextStyle: '{"font-weight": "700"}'
  }
]`;
const CustomStylingStory: Story = {
  title: 'Custom styles',
  description: 'A nav bar with custom styling applied',
  coreComponent: {
    html: `<tag-nav></tag-nav>`,
    js: `var nav = document.querySelector('tag-nav');
var items = ${customStylesArray}

nav.componentOnReady().then(function() {
  nav.setData(items);
})`,
  },
  reactWrapper: {
    jsx: `<TagNav
  listItemOpenMenuLinkStyle={{backgroundColor: "#712e58"}}
  listItemSelectedLinkTextStyle={{fontWeight: "700"}}
  items={${customStylesArray}}
/>`,
  },
};

export const TagNavDocs: Component = {
  type: 'component',
  name: 'nav',
  description: 'Renders a a multi-level left hand navigation bar for big apps',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'items',
      description: 'The list of items you wish your navigation menu to display',
      type: `{
        id?: string;
        text?: string;
        icon?: Icon;
        iconClass?: string;
        children?: INavItem[];
        href?: string;
        badgeText?: string;
        badgeAccent?: Accent;
        defaultOpen?: boolean;
        depth?: number;
        containerStyle?: string;
        listStyle?: string;
        listItemStyle?: string;
        listItemLinkStyle?: string;
        listItemLinkTextStyle?: string;
        listItemOpenMenuStyle?: string;
        listItemOpenMenuLinkStyle?: string;
        listItemOpenMenuLinkTextStyle?: string;
        listItemSelectedStyle?: string;
        listItemSelectedLinkStyle?: string;
        listItemSelectedLinkTextStyle?: string;
      }[]`,
    },
    {
      name: 'collapsed',
      description: 'Whether the navigation is collapsed or not horizontally.',
      type: 'boolean',
    },
    {
      name: 'hideTextOnCollapsed',
      description: 'Whether the text in the nav items is hidden when the navigation is collapsed.',
      type: 'boolean',
    },
    {
      name: 'width',
      description: 'The width',
      type: 'string',
    },
    {
      name: 'selectedMenuItemId',
      description:
        'The Id of the menu item that is currently selected. This can be used to set a selected item by default.',
      type: 'string',
    },
    { name: 'containerStyle', description: 'JSON style object for the outer div', type: 'string' },
    { name: 'listStyle', description: 'JSON style object for the ul', type: 'string' },
  ],
  reactPropOverrides: [],
  methods: [
    {
      name: 'setData',
      description: 'Sets the data of the element',
      parameters: [
        {
          name: 'data',
          description: 'The items data',
          type: 'any',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'updateBadge',
      description: 'Updates the badge of an item',
      parameters: [
        {
          name: 'itemId',
          description: 'The id of the item to be updated',
          type: 'string',
        },
        {
          name: 'badgeText',
          description: 'The new badge text',
          type: 'string',
        },
      ],
      returnType: 'boolean',
    },
    {
      name: 'showItem',
      description: 'Shows an item',
      parameters: [
        {
          name: 'item',
          description: 'The item to be opened',
          type: 'NavItem',
        },
        {
          name: 'element',
          description: 'The element the contains the item',
          type: 'any',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'closeItem',
      description: 'Closes the nav',
      parameters: [],
      returnType: 'void',
    },
  ],
  events: [
    {
      name: 'navClicked',
      description: 'Raised when an item with no children and no URL is clicked',
      parameters: [
        {
          name: 'item',
          description: 'The item that was clicked',
          type: 'NavItem',
        },
      ],
    },
    {
      name: 'navClosed',
      description: 'Raised when an item is closed',
      parameters: [],
    },
    {
      name: 'navItemClicked',
      description: 'Raised when any item is clicked',
      parameters: [
        {
          name: 'item',
          description: 'The item that was clicked',
          type: 'NavItem',
        },
      ],
    },
  ],
  stories: [FourLevelStory, CustomStylingStory],
};
